import { estimateShippingCost } from '../firebase';
import { DEFAULT_QUIKBAK_FEE } from './shippingUtils';

export async function fetchShippingEstimate({ matchId, countryName, countryCode = '', currency }) {
  if (!matchId || !countryName) {
    return {
      shippingCost: null,
      quikbakFee: DEFAULT_QUIKBAK_FEE,
      totalAmount: null,
      currency: (currency || 'jpy').toLowerCase(),
      countryName: countryName || '',
      countryCode: countryCode || '',
    };
  }

  const response = await estimateShippingCost({
    matchId,
    country: countryName,
    countryCode,
  });

  const data = response?.data || response;

  const parsedCountryName = typeof data?.country === 'string' && data.country.trim() !== ''
    ? data.country
    : countryName;

  const parsedCountryCode = typeof data?.countryCode === 'string' && data.countryCode.trim() !== ''
    ? data.countryCode
    : countryCode;

  return {
    shippingCost: typeof data?.shippingCost === 'number' ? data.shippingCost : null,
    quikbakFee: typeof data?.quikbakFee === 'number' ? data.quikbakFee : DEFAULT_QUIKBAK_FEE,
    totalAmount: typeof data?.totalAmount === 'number' ? data.totalAmount : null,
    currency: (data?.currency || currency || 'jpy').toLowerCase(),
    countryName: parsedCountryName,
    countryCode: parsedCountryCode || '',
  };
}
